<template>
    <div class='binding'>
        <div class="binding-title">{{$t('login.bind')}}</div>
        <v-form
           @submit.native.prevent
            v-model="valid"
            class="mb-6"
            ref="bindingForm">
            <v-text-field
                v-model="formData.password"
                outlined
                hide-details="auto"
                required
                min-height="46"
                color="#5066e0"
                class="mb-9 input-h-md"
                :rules="bindingRules.password"
                :type="isPasswordVisible ? 'text' : 'password'"
                :append-icon="isPasswordVisible ? icons.mdiEyeOutline:icons.mdiEyeOffOutline"
                @click:append="isPasswordVisible = !isPasswordVisible"
                :placeholder="$t('login.passwordPlaceholder')"
                @keydown="keydown"
            ></v-text-field>

            <v-btn color="primary" min-height="50" class="btn-box w-full" @click="onSubmit">{{$t('login.bind')}}</v-btn>
        </v-form>
    </div>
</template>

<script>
import { authBind } from "@/api/index";
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import store from '@/store'
export default {
    data() {
        return {
            formData: {},
            bindingRules: {
                password: [
                    v => !!v || this.$t('login.putPwd'),
                    // { validator: this.validatePass }
                ],
            },
            valid: false,
            isPasswordVisible: false,
            icons: {
                mdiEyeOutline,
                mdiEyeOffOutline
            },
        };
    },
    props: {
        bindingToken: String
    },
    created() {

    },
    methods: {
        onSubmit() {
            if (this.$refs.bindingForm.validate()) {
                this.$passwordEncryption(this.formData.password).then(password=> {
                    let params = {
                        password: password,
                        reqId:sessionStorage.getItem("reqId"),
                        bindToken:  this.bindingToken,
                        appDomainName: window.location.href
                    }
                    if (window.location.href.indexOf("/yxl-bind") > -1) {
                        params.reqId = sessionStorage.getItem("fastPassReqId")
                    }
                    authBind(params).then(res=> {
                        if(res.code == this.$GLOBA.StatusOK) {
                            this.$emit("bindingFun", 7, res)
                        } else if (res.code == this.$GLOBA.StatusAcceptedUpdatePwd) {
                            this.$emit("bindPwd", res.data.updatePwdToken)
                        }else if(res.code == 201) {
                            this.$emit("authMfaFunc", res.data.authenticators)
                        }else if(res.code == 203) {
                            //绑定成功后　验证围栏
                            this.$emit("authQrCode", res.data.qrCode)
                        }else if(res.code == 302){
                            window.location.href = res.data.redirectUrl
                        }else{
                            store.dispatch('snackbar/openSnackbar',{
                                snackbarText: res.message,
                                colorType: 'error'
                            })
                        }
                    })
                })
            } else {
                return false;
            }
        },
        keydown(e) {
            if(e.key == "Enter") {
               this.onSubmit()
            }
        },
        // validatePass(rule, value, callback) {
        //     this.$checkPassword(value, callback)
        // },
    },
}
</script>

<style lang='scss' scoped>
.binding {
    // flex: 1;
    width: 365px;
    // padding-top:8%;
    // margin-left: 250px;
    z-index: 15;
    // .form-box ::v-deep {
    //     padding: 50px 0;
    //     .ant-form-item {
    //         margin-bottom: 30px;
    //     }
    //     .ant-input {
    //         font-size: 16px;
    //         height: 46px;
    //         border-radius: 10px;
    //         padding-left: 20px;
    //         // background-color: #F5F5F5;
    //         // border: none;
    //     }
    //     .ant-input:focus {
    //         box-shadow:none;
    //     }
    //     // .ant-form-explain {
    //     //     padding-left: 30px;
    //     // }
    //     .btn-box {
    //         width: 100%;
    //         height: 46px;
    //         line-height: 46px;
    //         background: #5066e0;
    //         box-shadow: 0px 0px 10px 1px rgba(0, 80, 179, 0.2);
    //         border-radius: 10px;
    //         font-size: 18px;
    //         font-weight: 500;
    //         color: #FFFEFE;
    //         margin-top: 10px;
    //     }
    // }
    // .ant-input-password ::v-deep {
    //     .ant-input-suffix {
    //         right: 20px;
    //     }
    // }
}
.binding-title {
    height: 70px;
    line-height: 70px;
    // padding-left: 95px;
    // border-bottom: 1px solid rgba(0,0,0,.12);
    font-size: 32px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 50px;
}
</style>
